<template>
 <div>
    <add-to-cal
      :title="$parent.event.name"
      :startep="$parent.event.startep"
      :endep="$parent.event.endep"
      :descr="$parent.event.descr"
      :url="get_event_url($parent.event)"
      :nopop="true"
    />
 </div>
</template>

<script>

import { sync } from "vuex-pathify";
import store from "../store";
import utils from "../eventutils";
import AddToCal from "../components/AddToCal";

export default {
  name: "eventcal",
  data() {
    return {
    };
  },
  components: {
    AddToCal
  },
  created() {
  },
  methods: {
   get_event_url: function(event) {
        let vue = this;
        let hash = vue.$router.resolve({ name: 'event',
                                         id: event.id}).href;
        let url;
        if (vx.staging) {
           url = "https://uploadvue-app.staging.vuemix.com";
        } else {
           url = "https://vcafe-app.vuemix.com";
        }
        url += window.location.pathname + hash;
        return url;
   },
  },
};
</script>

<style lang="scss" scoped>
</style>